import { PayloadAction } from "@reduxjs/toolkit";
import { Page } from "../../../../utl/models/Page";
import { VendorsState } from "../models/VendorsState";

const setPageVendors = (state: VendorsState, action: PayloadAction<Page>) => {
    state.page = action.payload.page;
}

export default setPageVendors;